import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Auth from "service/AuthService";
import { useAuth } from "provider/AuthContext";
import InputField from "components/ui/forms/InputField";
import { REGEX_EMAIL, REQUIRED_FIELD } from "helper/Validation";
import InputSelect from "components/ui/forms/InputSelect";
import { COUNTRIES_OPTIONS, SUBSCRIBE_OPTIONS } from "config/DATA";
import Button from "components/ui/Button";
import { FormMessage } from "components/ui/forms/FormMessage";
import InputRC from "components/ui/forms/InputRC";
import { isEmpty } from "helper/Functions";
import InputDatePicker from "components/ui/forms/InputDatePicker";
import { useTranslation } from "react-i18next";

const ProfileDetail = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
  });

  const onSubmit = async (data) => {
    setIsLoading(true);
    //console.log(data);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  useEffect(() => {
    setValue("username", user.username);
    setValue("userId", user.c_id);
    setValue("email", user.email);
  });

  const subcribeOptions = SUBSCRIBE_OPTIONS();

  return (
    <>
      <h2 className=" text-slate-400 mb-2 text-sm">
        <i className="bc-i-player-info" /> {t("Eligible for bonus")} <span className="text-green-500">{t("yes")}</span>
      </h2>
      <form className="relative" onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <div className="md:max-h-[calc(100vh-280px)] max-h-[calc(100vh-240px)] overflow-y-auto pr-1 md:pb-0 pb-7">
          <InputField className="mb-2" name="userId" label="ID" control={control} {...register("userId")} disabled />
          <div className="grid md:grid-cols-2 grid-cols-1 gap-x-3 gap-y-2 mb-6">
            <InputField name="username" label="Username" control={control} {...register("username")} disabled />
            <InputField name="firstName" label="First Name" control={control} {...register("firstName", { required: REQUIRED_FIELD })} />
            <InputField name="lastName" label="Last Name" control={control} {...register("lastName", { required: REQUIRED_FIELD })} />
            <InputDatePicker
              selectsStart
              label="Birth Date"
              placeholderText=""
              name="birthDate"
              control={control}
              selected={watch("birthDate")}
              maxDate={new Date()}
              {...register("birthDate")}
              onChange={(date) => {
                setValue("birthDate", date);
              }}
            />

            <InputSelect
              label="Gander"
              name="gender"
              placeholder="Choose Gender"
              control={control}
              options={[
                { value: "male", label: "Male" },
                { value: "female", label: "Female" },
              ]}
              {...register("gender", { required: REQUIRED_FIELD })}
            />
            <InputField
              disabled
              name="email"
              label="Email"
              control={control}
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: REGEX_EMAIL,
                  message: "Please enter a valid email address",
                },
              })}
              error={errors.username?.message}
            />

            <InputField name="passportOrId" label="Passport / ID" control={control} {...register("passportOrId")} />

            <InputSelect
              disabled
              searchable
              label="Country"
              name="country"
              control={control}
              options={COUNTRIES_OPTIONS}
              defaultValue={COUNTRIES_OPTIONS[0]}
            />
            <InputField name="city" label="City" control={control} {...register("city")} />
            <InputField name="address" label="Address" control={control} {...register("address")} />
            <InputField name="mobileNumber" label="Mobile Number" control={control} {...register("mobileNumber")} />
          </div>
          <div className="flex flex-col gap-2 mt-2">
            <FormMessage className="text-center" message={errorMessage ? errorMessage : t("Subscribe for")} />
            <ul className=" py-1 border-y border-white/15">
              {subcribeOptions.map((item, index) => (
                <li key={index} className="flex my-1 justify-between text-sm">
                  <span className="text-white/60">{item.label}</span>
                  <div className="flex gap-6">
                    <InputRC type="radio" name={item.value} value="yes" label={t("yes")} register={register} checked />
                    <InputRC type="radio" name={item.value} value="no" label={t("no")} register={register} />
                  </div>
                </li>
              ))}
            </ul>
            {/* {errorMessage && <FormMessage message={errorMessage} />} */}
            <FormMessage className="text-center" message={errorMessage ? errorMessage : t("Enter your password to save changes")} />
            <InputField
              type={"password"}
              name="currentPassword"
              label="Current Password"
              control={control}
              {...register("currentPassword", {
                required: "Password is required",
              })}
              error={errors.currentPassword?.message}
            />
          </div>
        </div>
        <div className="bg-body w-full z-10 sticky bottom-0 pt-5">
          <Button
            label={isLoading ? "Logging in..." : t("Save Changes")}
            type="submit"
            size="small"
            variant="green"
            className="uppercase md:max-w-[370px] w-full ml-auto"
            disabled={errors.length || isEmpty(watch("currentPassword")) ? true : false}
          />
        </div>
      </form>
    </>
  );
};

export default ProfileDetail;
